var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53092 10.4695L6.53091 10.4695L2.06085 6.00003L6.53091 1.53057L6.53092 1.53056C6.67162 1.38986 6.75067 1.19902 6.75067 1.00003C6.75067 0.801047 6.67162 0.610211 6.53092 0.469507C6.39022 0.328802 6.19938 0.249756 6.00039 0.249756C5.80141 0.249756 5.61057 0.328802 5.46987 0.469507L0.469965 5.46941C0.469937 5.46944 0.469894 5.46948 0.469866 5.46951C0.400172 5.53915 0.344898 5.62182 0.30717 5.71283C0.269427 5.80388 0.25 5.90147 0.25 6.00003C0.25 6.0986 0.269427 6.19619 0.30717 6.28724C0.344895 6.37824 0.400179 6.46093 0.469866 6.53056C0.469899 6.53059 0.469932 6.53063 0.469965 6.53066L5.46987 11.5306C5.53954 11.6002 5.62225 11.6555 5.71327 11.6932C5.8043 11.7309 5.90186 11.7503 6.00039 11.7503C6.09892 11.7503 6.19649 11.7309 6.28751 11.6932C6.37854 11.6555 6.46125 11.6002 6.53092 11.5306C6.60059 11.4609 6.65585 11.3782 6.69356 11.2872C6.73126 11.1961 6.75067 11.0986 6.75067 11C6.75067 10.9015 6.73126 10.8039 6.69356 10.7129C6.65585 10.6219 6.60059 10.5392 6.53092 10.4695Z",
    fill: "#FF7A2A",
    stroke: "#FF7A2A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconButton);
export default __webpack_public_path__ + "static/media/BackIconButton.ede674cbb46b87b337f336b43bdc811f.svg";
export { ForwardRef as ReactComponent };